import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-h5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-h5" }, "А", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "pa-4 text-body-2" }, [
  /*#__PURE__*/_createTextVNode(" По вопросам работы сервиса обращаться "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-decoration-none",
    href: "mailto:smp@donland.ru"
  }, "smp@donland.ru")
], -1)

import { Role, User } from '@prodcard/core'
import { NavigationLink, NavigationLinkGroup } from './interfaces'
import VNavigationLinks from './VNavigationLinks.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VNavigation',
  props: {
    currentUser: {},
    currentRole: {},
    links: {},
    stateDrawer: { type: Boolean },
    enableAdditionalLogin: { type: Boolean }
  },
  emits: ["update:state-drawer", "logout", "login"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    "model-value": _ctx.stateDrawer,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:state-drawer', $event))),
    elevation: "0",
    width: "300",
    border: ""
  }, {
    append: _withCtx(() => [
      _createVNode(_component_v_divider),
      _hoisted_3
    ]),
    default: _withCtx(() => [
      (_ctx.currentUser)
        ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                title: `${_ctx.currentUser.surname} ${_ctx.currentUser.name}`,
                subtitle: _ctx.currentRole?.name
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    color: "primary",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.currentUser.surname[0] + _ctx.currentUser.name[0]), 1)
                    ]),
                    _: 1
                  })
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_menu, null, {
                    activator: _withCtx(({ props }) => [
                      (_ctx.enableAdditionalLogin)
                        ? (_openBlock(), _createBlock(_component_v_badge, {
                            key: 0,
                            dot: "",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, _mergeProps(props, {
                                size: "small",
                                variant: "text",
                                icon: "mdi-menu-down"
                              }), null, 16)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 1 }, props, {
                            size: "small",
                            variant: "text",
                            icon: "mdi-menu-down"
                          }), null, 16))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_ctx.enableAdditionalLogin)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('login')))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_badge, {
                                    dot: "",
                                    color: "primary",
                                    inline: ""
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, { color: "primary" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Авторизоваться ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, { to: "/profile" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Профиль")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logout')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Выход")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title", "subtitle"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { title: "Аноним" }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    color: "primary",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "xl",
                    variant: "text",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('login')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Войти")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (_ctx.currentUser)
        ? (_openBlock(), _createBlock(_component_v_divider, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_list, {
        color: "primary",
        density: "compact",
        "open-strategy": "list",
        nav: "",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _createVNode(VNavigationLinks, { items: _ctx.links }, null, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})